import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import cssVars from 'css-vars-ponyfill';
import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.scss";
import App from "components/app";
import * as serviceWorker from "./serviceWorker";
import { ApolloProvider } from "@apollo/client/react";
import { HelmetProvider } from "react-helmet-async";
import createClient from "create-apollo-client";

const client = createClient();
cssVars();
const container = document.getElementById("root");

// react-helmet-async requires a provider around anything that renders <Helmet>,
// unlike react-helmet which used a global. Only SeomaticHelmet does.
const app = (
  <HelmetProvider>
    <BrowserRouter>
      <ApolloProvider client={client}>
        <App />
      </ApolloProvider>
    </BrowserRouter>
  </HelmetProvider>
);

// Hydrate whenever the container already holds server-rendered markup, which is
// every request served by the SSR server. This replaces a `module.hot ? render :
// hydrate` switch that never hydrated in development — so hydration mismatches,
// the main risk of React 18, could only ever surface in production. The
// createRoot branch covers the CRA dev server, where the container is empty.
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
